import React from 'react'

import { withFormsy } from 'formsy-react'

import AutocompleteEditor from '@Components/AutocompleteEditor'

import MergetagEditorFrame from './EditorFrame'

export default function MergetagEditor({ mergetags = [], mode, label, disabled, ...props }) {
  return <MergetagEditorFrame
    mergetags={mergetags}
    mode={mode}
    label={label}
    disabled={disabled}
    hint={'Click \'Mergetag\' or type { to insert a mergetag'}
  >
    <AutocompleteEditor {...props} mode={mode} keywords={mergetags} meta='mergetags' />
  </MergetagEditorFrame>
}

export const MergetagEditorFormsy = withFormsy(MergetagEditor)
